import Hero from "@/components/landing/Hero";
import Destinations from "@/components/landing/Destinations";
import Deals from "@/components/landing/Deals";
import CallPromo from "@/components/landing/CallPromo";
import WhyUs from "@/components/landing/WhyUs";
import PopularRoutes from "@/components/landing/PopularRoutes";
import Blog from "@/components/landing/Blog";
import Testimonials from "@/components/landing/Testimonials";
import Newsletter from "@/components/landing/Newsletter";
import Footer from "@/components/Footer";
import { useSEO, organizationSchema, websiteSchema } from "@/lib/seo";

export default function Landing() {
  useSEO({
    title: "TheCityPair — Premium Flight Reservations",
    description:
      "Premium and business-class flight reservations from the United States. Curated routes, unpublished fares, and a real travel desk on call 24/7.",
    canonical: "/",
    jsonLd: [organizationSchema(), websiteSchema()],
  });

  return (
    <div className="App flex flex-col md:block" data-testid="landing-page">
      <div className="order-1 md:order-none"><Hero /></div>
      <div className="order-3 md:order-none"><Destinations /></div>
      <div className="order-2 md:order-none"><Deals /></div>
      <div className="order-4 md:order-none"><CallPromo /></div>
      <div className="order-5 md:order-none"><WhyUs /></div>
      <div className="order-6 md:order-none"><PopularRoutes /></div>
      <div className="order-7 md:order-none"><Blog /></div>
      <div className="order-8 md:order-none"><Testimonials /></div>
      <div className="order-9 md:order-none"><Newsletter /></div>
      <div className="order-10 md:order-none"><Footer /></div>
    </div>
  );
}
